import { schema } from "normalizr";
import { Chargeback } from "./chargeback";

export const Chargebacks = new schema.Array(Chargeback);
